<div class="language-settings-container d-flex flex-column">
    <div class="language-settings-content">
        <p>{{'SELECT_YOUR_PREFERRED_DISPLAY_LANGUAGE' | translate}}</p>
        <mat-form-field appearance="outline" class="language-select">
            <mat-label>{{'NAVIGATION_BAR_LANGUAGES' | translate}}</mat-label>
            <mat-select [(value)]="selectedLanguage">
                <mat-option value="en-US">English (US)</mat-option>
                <mat-option value="en-CA">English (CA)</mat-option>
                <mat-option value="fr-CA">French (CA)</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="language-settings-footer d-flex justify-content-end">
        <button mat-raised-button color="primary" (click)="saveLanguagePreference()">{{'COMMON_DIALOGS_BTN_LABELS_OK' | translate}}</button>
        <button mat-raised-button mat-dialog-close color="warn" (click)="onCancel()">{{'COMMON_DIALOGS_BTN_LABELS_CANCEL' | translate}}</button>
    </div>
    
</div>